import { useMemo } from 'react';

import { isFileResource, RESOURCE_CONTENT_TYPE } from 'src/data/performance';
import { useResources } from 'src/services/useResources';

export const useAvailableResources = ({ provideUrlResources, provideFileResources }) => {
  const { resources } = useResources();

  return useMemo(() => {
    let result = resources || [];

    if (!provideUrlResources) {
      result = result.filter((resource) => resource.contentType !== RESOURCE_CONTENT_TYPE.url);
    }
    if (!provideFileResources) {
      result = result.filter((resource) => !isFileResource(resource));
    }

    return result;
  }, [resources, provideUrlResources, provideFileResources]);
};
